import React from 'react';
import { Card } from 'primereact/card';
import { ProgressSpinner } from 'primereact/progressspinner';

const GoldAssetSummary = ({ data }) => {
    if (!data) {
        return <ProgressSpinner />;
    }

    const items = [
        { label: 'Total Assets', value: data.totalAssets || 0 },
        { label: 'Total Items', value: data.totalItems || 0 },
        { label: 'Net Weight (g)', value: (data.totalNetWeight || 0).toFixed(2) },
        { label: 'Gross Weight (g)', value: (data.totalGrossWeight || 0).toFixed(2) },
        { label: 'Total Value', value: `₹${(data.totalValue || 0).toLocaleString()}` },
        { label: 'Avg Purity', value: `${(data.averagePurity || 0).toFixed(2)}%` },
        { label: 'Avg Lending Rate', value: `₹${(data.averageLendingRate || 0).toFixed(2)}` },
        { label: 'Avg Current Rate', value: `₹${(data.averageCurrentRate || 0).toFixed(2)}` }
    ];

    return (
        <Card className="gold-asset-summary-card">
            <div className="card-header">
                <h3>Gold Asset Summary</h3>
            </div>
            <div className="gold-asset-summary">
                {items.map((item, index) => (
                    <div key={index} className="gold-asset-item">
                        <div className="value">{item.value}</div>
                        <div className="label">{item.label}</div>
                    </div>
                ))}
            </div>
            {data.byItemType && data.byItemType.length > 0 && (
                <div className="asset-breakdown">
                    <h4>By Item Type</h4>
                    <div className="item-type-list">
                        {data.byItemType.map((item, index) => (
                            <div key={index} className="item-type-row">
                                <span>{item.itemType || 'N/A'}</span>
                                <span>{item.count} items</span>
                                <span>₹{(item.totalValue || 0).toLocaleString()}</span>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </Card>
    );
};

export default GoldAssetSummary;
